import { NavBar } from '../interfaces/nav-bar.model';

export const NAVBAR: NavBar[] = [
    { id: "mvp", fa: "fas fa-2x fas fa-flag-checkered", name: "Build Your App", url: "mvp" },
    { id: "outSourcing", fa: "fas fa-2x fa-people-carry", name: "More Muscle", url: "out-sourcing" },
    { id: "firstAid", fa: "fa fa-2x fas fa-fire", name: "App Magic", url: "first-aid" },
];
